import { forwardRef } from 'react';

import { ChevronRight } from '../Icons';
import * as Styled from './Carousel.styles';

const CarouselPrevious = forwardRef(
  ({ className, disabled, ...props }, ref) => {
    return (
      <Styled.NavButton
        ref={ref}
        type="button"
        className={className}
        disabled={disabled}
        {...props}
      >
        <Styled.ChevronLeft>
          <ChevronRight />
        </Styled.ChevronLeft>
      </Styled.NavButton>
    );
  },
);

CarouselPrevious.displayName = 'CarouselPrevious';

export default CarouselPrevious;
